import useMutationHook from '@/hooks/useMutationHook';
import { API, URLs } from '@/api';

export const UploadImage = () => {
    const {
        mutateAsync: uploadImage,
        errorPopUp,
        data,
    } = useMutationHook(
        ['upload-image'],
        async (file: File) => {
            return API.post(URLs.temp.uploadFile, { uploads: [file] });
        },
        {
            onError: err => errorPopUp(err?.response?.status),
        },
    );

    return { uploadImage, data };
};
